module.exports = __webpack_public_path__ + "media/images/countryrect/so-719c3827986d0043c3eacf121ac4346b.svg";